export default __webpack_public_path__ + "static/media/gallery_06.73a4a879.jpg";